var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { number } from 'prop-types';
import styled, { css } from 'styled-components';
var Line = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var width = _ref.width,
      stepper = _ref.theme.yoga.components.stepper;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 4px;\n\n    background-color: ", ";\n\n    &:after {\n      display: block;\n      content: '';\n\n      width: ", "%;\n      height: 4px;\n\n      background-color: ", ";\n    }\n  "])), stepper.line.backgroundColor.inactive, width, stepper.line.backgroundColor.active);
});
Line.propTypes = {
  activeStep: number,
  totalSteps: number
};
Line.defaultProps = {
  activeStep: 0,
  totalSteps: 0
};
export default Line;